import { render, staticRenderFns } from "./InformeLiquidacion.vue?vue&type=template&id=9bb2bcc0"
import script from "./InformeLiquidacion.vue?vue&type=script&lang=js"
export * from "./InformeLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports